import {formatDateAndTime, serverLink} from "../../../url";
import React, {useEffect, useState} from "react";
import axios from "axios";
import Loader from "../../../common/loader";
import DataTable from "../../../common/data-table/data-table";
import {connect} from "react-redux";
import {showConfirm} from "../../../common/sweetalert/sweetalert";
import {toast} from "react-toastify";

const AntenatalPregnancy = ({patientSerial, loginData, handleRemount}) => {
    const token = loginData[0]?.token;
    const [IsLoading, setIsLoading] = useState(true)
    const [pregnancyList, setPregnancyList] = useState([])
    const header = ["S/N", "Year", "Duration", "Complications",  "Labor", "Is Alive", "Age At Death", "Cause Of Death", "Status", "Action"];

    useEffect( () => {
        getData();
    }, [handleRemount]);


    const getData = async () => {
        setIsLoading(true);
        try {
            const result = await axios.get(`${serverLink}antenatal/pregnancy/list/${patientSerial}`, token);

            if (result.data.data.length > 0) {
                setPregnancyList(result.data.data);
            } else {
                setPregnancyList([]);
            }

        } catch (error) {
            console.error("NETWORK ERROR", error);
        } finally {
            setIsLoading(false);
        }
    };

    const  showTable = () => {
        try {
            return pregnancyList.length > 0 &&  pregnancyList.map((item, index) => {
                return (
                    <tr key={index}>
                        <td>{index +1}</td>
                        <td>{item.year}</td>
                        <td>{item.duration}</td>
                        <td>{item.complications}</td>
                        <td>{item.labour}</td>
                        <td>{item.isAlive === 1 ? 'Yes' : 'No'}</td>
                        <td>{item.ageAtDeath}</td>
                        <td>{item.causeOfDeath}</td>
                        <td>{item.status}</td>
                        <td>
                            {loginData[0]?.userID !== item.submittedBy ? <>--</> :
                                <a href="#" className={"btn btn-primary btn-sm "}
                                   onClick={() => {
                                       showConfirm("Warning", `Are you sure you want to add pregnancy outcome?`, "warning")
                                           .then( async (confirm) => {
                                               if (confirm) {
                                                   delete_item(item.pregnancyID)
                                               }
                                           })
                                   }}>
                                    Add Pregnancy Outcome
                                </a> }</td>
                    </tr>
                );
            });
        } catch (e) {
            alert(e.message);
        }
    };

    const delete_item = async (id) => {
        toast.info("please wait...");
        // await axios.delete(`${serverLink}patient/allergy/delete/${id}`).then((res) => {
        //     if (res.data.message === "success") {
        //         toast.success("Deleted Successfully");
        //         getData();
        //     } else {
        //         toast.error("NETWORK ERROR. Please try again!");
        //     }
        // }).catch((err) => {
        //     console.log(err);
        //     toast.error("NETWORK ERROR. Please try again!");
        // });
    }

    return (IsLoading ? <Loader/> :
            <div className="">
                <div className="table-responsive">
                    <h5 className="card-title">Pregnancy</h5>
                    <DataTable tableID="patient-pregnancy" header={header} body={showTable()} title="Pregnancy Report"/>
                </div>
            </div>
    )
}
const mapStateToProps = (state) => {
    return {
        loginData: state.LoginDetails,
    };
};
export default connect(mapStateToProps, null)(AntenatalPregnancy);

